const generateCountyId = function (countyName = '', stateName = '') {
  return `${countyName}, ${stateName}`;
};

export { generateCountyId };
